import AuditList from "../../slices/report/audit/AuditList";
import AuditDetails from "../../slices/report/audit/AuditDetails";
import AssetDepreciationReport from "../../slices/report/asset_depreciation/AssetDepreciationReport";
import AssetAgeReport from "../../slices/report/asset_age/AssetAgeReport";
import AssetMovementReport from "../../slices/report/asset_movement/AssetMovementReport";
import AssetsDueDisposalReport from "../../slices/report/assets_due_disposal/AssetsDueDisposalReport";
import DowntimeAnalysisReport from "../../slices/report/downtime_analysis/DowntimeAnalysisReport";

import WorkOrderSummaryReport from "../../slices/report/work_order_summary/WorkOrderSummaryReport";
import MaintenanceHistoryAssetReport from "../../slices/report/maintenance_history_asset/MaintenanceHistoryAssetReport";
import PlannedVsActualReport from "../../slices/report/planned_vs_actual/PlannedVsActualReport";
import OverdueMaintenanceReport from "../../slices/report/overdue_maintenance/OverdueMaintenanceReport";
import AmcReport from "../../slices/report/amc/AmcReport";

const reportReducer = {
    auditList: AuditList,
    auditDetails: AuditDetails,
    assetDepreciationReport: AssetDepreciationReport,
    assetAgeReport: AssetAgeReport,
    assetMovementReport: AssetMovementReport,
    assetsDueDisposalReport: AssetsDueDisposalReport,
    downtimeAnalysisReport: DowntimeAnalysisReport,
    workOrderSummaryReport: WorkOrderSummaryReport,
    maintenanceHistoryAssetReport: MaintenanceHistoryAssetReport,
    plannedVsActualReport: PlannedVsActualReport,
    overdueMaintenanceReport: OverdueMaintenanceReport,
    amcReport: AmcReport,
};

export default reportReducer;
